import { ADD_OPTIONALS_BY_SUB_LOT, PUSH_OPTIONALS_BY_SUB_LOT, REMOVE_OPTIONALS_BY_SUB_LOT,LOAD_OPTIONALS_STORE_BY_LOT } from '../types';


export const addOptionalsBySubLot = (nOptionalId, aOptionalIds) => dispatch => {
    const optionals = {
        [nOptionalId]: aOptionalIds
    }
    return dispatch({
        type: ADD_OPTIONALS_BY_SUB_LOT,
        payload: optionals
    });
}
export const loadOptionalsStoreByLot = (oOptionals) => dispatch =>{
    return dispatch({
        type: LOAD_OPTIONALS_STORE_BY_LOT,
        payload: oOptionals
    });
}

export const updateCheckedOptionalsbySubLot = (nSubLotId, nOptionalId, bIsChecked) => dispatch => {

    if (bIsChecked) {
        return dispatch({
            type: PUSH_OPTIONALS_BY_SUB_LOT,
            payload: { subLotId: nSubLotId, optionalId: nOptionalId }
        });
    }
    return dispatch({
        type: REMOVE_OPTIONALS_BY_SUB_LOT,
        payload: { subLotId: nSubLotId, optionalId: nOptionalId }
    });
}


export const getcheckedOptionalsBySubLotId = (state, nSubLotId) => {
    return state.subLotCarOptionals[nSubLotId] || [];
}


// WEBPACK FOOTER //
// ./src/store/actions/carOptionals/carOptionalsActions.js